import React from 'react';

import { clsx } from 'clsx';

import { Spinner } from '@af-fp/components/Spinner';
import SectionHeader from '@af-fp/components/typography/SectionHeader';

export type LoadingBlockProps = {
  className?: string;
};

export const LoadingBlock: React.FC<LoadingBlockProps> = (props: LoadingBlockProps) => {
  return (
    <div
      role='alert'
      aria-label='Loading'
      className={clsx('flex h-full min-h-80 flex-col items-center justify-center gap-8', props.className)}
    >
      <SectionHeader>Loading...</SectionHeader>
      <Spinner className='h-20 w-20' />
    </div>
  );
};
